import firebase from "firebase";
import "firebase/storage";

const firebaseConfig = firebase.initializeApp ({
    apiKey: "AIzaSyAx2ySZWu4pkHtUPml5JQaJWtgmi9yPzh4",
    authDomain: "alif-aisbook.firebaseapp.com",
    databaseURL: "https://alif-aisbook.appspot.com",
    projectId: "alif-aisbook",
    storageBucket: "alif-aisbook.appspot.com",
    messagingSenderId: "564633740482",
    appId: "1:564633740482:web:9d952e0147f8d42042c75b"
   });
  

 //export const firebaseApp = firebase.initializeApp(firebaseConfig);
  const db = firebaseConfig.firestore();
  const auth = firebase.auth();
  const storage = firebase.storage();
  const provider = new firebase.auth.GoogleAuthProvider();

 

 export {auth, provider, db ,storage};
  
  